export const convertDate = (date: string) => {
  return date && new Date(date).toLocaleDateString('en-ca');
};

export const excelSerialDateToJSDate = (serial: number) => {
  try {
    const startDate = new Date(Date.UTC(1900, 0, 1));
    const date = new Date(startDate.getTime() + (serial - 2) * 24 * 60 * 60 * 1000);
    return date.toISOString().split('T')[0];
  } catch {
    return serial
  }
  
}
export const formatDate = (date: Date | string | number | null | undefined): string | null => {
  if (date == null) return null;

  try {
    if (typeof date === 'number') {
      const jsDateStr = excelSerialDateToJSDate(date);
      if (!jsDateStr) return null;
      
      const jsDate = new Date(jsDateStr);
      if (isNaN(jsDate.getTime())) return null;
      
      return jsDate.toLocaleDateString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } 
    else if (date instanceof Date) {
      if (isNaN(date.getTime())) return null;
      
      return date.toLocaleDateString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } 
    else if (typeof date === 'string') {
      const dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) {
        const parts = date.split(/[\/\-\.]/);
        if (parts.length === 3) {
          const month = parseInt(parts[0], 10) - 1;
          const day = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          
          if (month >= 0 && month < 12 && day > 0 && day <= 31 && year > 0) {
            const parsedDate = new Date(year, month, day);
            // Make sure that the date is valid (e.g., not 11/31/2000)
            if (parsedDate.getMonth() === month && parsedDate.getDate() === day) {
              return parsedDate.toLocaleDateString('vi-VN', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              });
            }
          }
        }
        return null;
      }
      
      return dateObj.toLocaleDateString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const isValidDate = (date: Date | string | number | null | undefined): boolean => {
  if (date == null) return false;
  
  try {
    // Nếu là số serial Excel
    if (typeof date === 'number') {
      const jsDateStr = excelSerialDateToJSDate(date);
      if (!jsDateStr) return false;
      
      const jsDate = new Date(jsDateStr);
      return !isNaN(jsDate.getTime());
    }
    // Nếu là chuỗi
    else if (typeof date === 'string') {
      // Try direct parsing
      const dateObj = new Date(date);
      if (!isNaN(dateObj.getTime())) return true;
      
      // Try manual parsing
      const parts = date.split(/[\/\-\.]/);
      if (parts.length === 3) {
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        
        if (month >= 0 && month < 12 && day > 0 && day <= 31 && year > 0) {
          const parsedDate = new Date(year, month, day);
          return parsedDate.getMonth() === month && parsedDate.getDate() === day;
        }
      }
      return false;
    }
    // Nếu là Date object
    else if (date instanceof Date) {
      return !isNaN(date.getTime());
    }
    return false;
  } catch (e) {
    return false;
  }
};